import script from "./RacingPageCoupons.vue?vue&type=script&setup=true&lang=js"
export * from "./RacingPageCoupons.vue?vue&type=script&setup=true&lang=js"

import "./RacingPageCoupons.vue?vue&type=style&index=0&id=35164c52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35164c52"]])

export default __exports__